import styled from 'styled-components';
import { BasicSelectField } from 'lib/iterable-hook-form/FormField';
import { pxToRem } from 'utils/convert';
import { Truncate } from 'ui/utility/truncate';
import { SelectOptionsContainer } from 'ui/selects';
import { body2, colors, spacing } from 'ui/theme';

export const Container = styled.div`
  margin-top: ${pxToRem(10)};
  width: 100%;
`;

export const Header = styled.div`
  font-size: 16px;
  margin-bottom: ${pxToRem(10)};
`;

export const Column = styled.div`
  margin-bottom: 0;
  font-weight: normal;
  ${body2};
  color: ${colors.textDisabled};
`;

export const LoadingWrapper = styled.div`
  width: 100%;
  align-items: center;
  padding: ${spacing.half};
  color: ${colors.grey25};
`;

export const StyledTruncate = styled(Truncate)`
  /** unsetting the white-space allows options to show fully in dropdown */
  white-space: unset;
`;

export const StyledSelectOptionsContainer = styled(SelectOptionsContainer)`
  width: ${pxToRem(225)};
`;

export const StyledBasicSelect = styled(BasicSelectField)<{ $isEmpty?: boolean }>`
  width: 100%;

  div button {
    /** maxWidth of the trigger */
    max-width: ${pxToRem(220)};
    > span {
      display: flex;
    }
    > div {
      > div {
        /** should match the CampaignTemplateOption maxWidth */
        max-width: ${pxToRem(160)};
        white-space: nowrap;
        overflow-x: hidden;
        text-overflow: ellipsis;
      }
    }
  }
`;

export const CampaignsColumnContainer = styled.div<{ $isCloneable: boolean }>`
  display: grid;
  grid-template-columns: ${({ $isCloneable }) =>
    $isCloneable
      ? `${pxToRem(80)} ${pxToRem(325)} ${pxToRem(225)} ${pxToRem(225)}`
      : `${pxToRem(80)} ${pxToRem(550)} ${pxToRem(240)}`};
  width: 100%;
  align-items: center;
  gap: ${pxToRem(15)};
`;

export const CampaignsRowContainer = styled.div<{ $isCloneable: boolean }>`
  display: grid;
  ${({ $isCloneable }) =>
    $isCloneable
      ? `grid-template-columns: ${pxToRem(65)} ${pxToRem(325)} ${pxToRem(225)} ${pxToRem(225)};
            > :not(:first-child) {
              color: ${colors.textPrimary};
            }
        `
      : `grid-template-columns: ${pxToRem(65)} ${pxToRem(550)} ${pxToRem(240)};
          > :nth-child(2) {
            color: ${colors.textPrimary};
          }
          > :last-child {
            justify-self: flex-end;
          }`};
  width: 100%;
  align-items: center;
  gap: ${pxToRem(15)};
  font-weight: normal;
  ${body2};
  color: ${colors.textDisabled};
`;

export const CampaignsTableContainer = styled.div<{
  $areOptionsLoaded: boolean;
  $isCloneable: boolean;
}>`
  ${({ $areOptionsLoaded, $isCloneable }) =>
    $areOptionsLoaded &&
    `margin-top: ${pxToRem(10)}; width: 100%; background-color: ${colors.backgroundSecondary};
      border: thin solid ${colors.grey10};
      border-radius: 5px;
      overflow-y: auto;
      display: flex;
      gap: ${pxToRem($isCloneable ? 10 : 20)};
      flex-direction: column;
      padding: ${pxToRem(15)};
      max-height: ${pxToRem(420)};
      ${$isCloneable && `min-height: ${pxToRem(180)}`};
  `};
`;

export const NoCloneableCampaignsText = styled.div`
  text-align: center;
  color: ${colors.textDisabled};
`;
